__turbopack_context__.v({
  "description": "searchResults-module-scss-module__cd6yDW__description",
  "noResults": "searchResults-module-scss-module__cd6yDW__noResults",
  "productLink": "searchResults-module-scss-module__cd6yDW__productLink",
  "productList": "searchResults-module-scss-module__cd6yDW__productList",
  "results": "searchResults-module-scss-module__cd6yDW__results",
  "sideBar": "searchResults-module-scss-module__cd6yDW__sideBar",
  "wrapper": "searchResults-module-scss-module__cd6yDW__wrapper",
});
